import {
  AttendanceType,
  AbsenceType,
  PaidLeaveType,
} from '@/class/common/const/labor-const';
import { ILaborCalendarEvent } from '@/class/models/typed/labor';

export type TimelineKind = 'work' | 'absence';

export interface TimelineEvent {
  id: number | string;
  kind: TimelineKind;
  start: string;
  end: string;
  isAllDay?: boolean;
  title?: string;
  absenceType?: string;
  note?: string;
  description?: string;
}

export function mapLaborEventToTimeline(
  apiEvent: ILaborCalendarEvent,
): TimelineEvent {
  const base = {
    id: apiEvent.id,
    note: apiEvent.description,
    description: apiEvent.description,
  };

  if (apiEvent.attendanceType === AttendanceType.ATTENDANCE) {
    return {
      ...base,
      kind: 'work',
      start: apiEvent.startTime ? apiEvent.startTime : '09:00',
      end: apiEvent.endTime ? apiEvent.endTime : '18:00',
      title: apiEvent.workCategoryName,
    };
  }

  if (apiEvent.attendanceType === AttendanceType.LATE_EARLY) {
    return {
      ...base,
      kind: 'absence',
      start: apiEvent.startTime ? apiEvent.startTime : '09:00',
      end: apiEvent.endTime ? apiEvent.endTime : '18:00',
      absenceType: '遅刻・早退',
      isAllDay: false,
    };
  }

  // absence
  let absenceType = '欠勤';
  let isAllDay = true;

  if (apiEvent.absenceType === AbsenceType.PAID_LEAVE) {
    absenceType =
      apiEvent.paidLeaveType === PaidLeaveType.HALF_DAY
        ? '有給（半日）'
        : '有給';
    isAllDay = apiEvent.paidLeaveType !== PaidLeaveType.HALF_DAY;
  }

  if (apiEvent.absenceType === AbsenceType.SPECIAL_LEAVE) {
    absenceType = apiEvent.specialLeaveName;
  }

  return {
    ...base,
    kind: 'absence',
    start: apiEvent.startTime ? apiEvent.startTime : '09:00',
    end: apiEvent.endTime ? apiEvent.endTime : '18:00',
    isAllDay,
    absenceType,
  };
}
